<script setup lang="ts">
  import type { HTMLAttributes } from "vue";
  import { computed } from "vue";
  import { Spinner } from "@/components/ui/spinner";
  import { cn } from "@/lib/utils";

  const props = withDefaults(
    defineProps<{
      label?: string;
      size?: "sm" | "default";
      class?: HTMLAttributes["class"];
    }>(),
    {
      label: undefined,
      size: "default",
      class: undefined,
    },
  );

  const paddingClass = computed(() => (props.size === "sm" ? "py-6" : "py-12"));
  const spinnerClass = computed(() => (props.size === "sm" ? "size-4" : "size-6"));
</script>

<template>
  <div :class="cn('flex items-center justify-center gap-2 text-muted-foreground', paddingClass, props.class)">
    <Spinner :class="spinnerClass" />
    <span
      v-if="label"
      class="text-sm">
      {{ label }}
    </span>
  </div>
</template>
